import { observer } from 'mobx-react-lite'
import { Typography } from 'shared/ui'
import { ChatbotFollowUpAssertiveness, type IChatbotFollowUpAssertiveness } from 'entities/Chatbot'
import { ChatbotTooltip } from 'pages/chatbot/ui/ChatbotTooltip'

import styles from './styles.module.scss'
import { type ITabsListItem, SettingsTabs } from './SettingsTabs'
import { DaysDropdown } from './DaysDropdown'

export interface IFollowUpWindowProps {
  followUpWindow: number
  followUpAssertiveness: IChatbotFollowUpAssertiveness
  setFollowUpWindow: (value: number) => void
  setFollowUpAssertiveness: (value: IChatbotFollowUpAssertiveness) => void
  tabsClassName?: string
}

export const AutoFollowUp = observer(
  ({
    followUpWindow,
    followUpAssertiveness,
    setFollowUpWindow,
    setFollowUpAssertiveness,
    tabsClassName,
  }: IFollowUpWindowProps) => {
    const followUpAssertivenessList: ITabsListItem[] = [
      {
        value: ChatbotFollowUpAssertiveness.Subtle,
        label: 'Subtle',
        icon: 'chart1',
      },
      {
        value: ChatbotFollowUpAssertiveness.Steady,
        label: 'Steady',
        icon: 'chart2',
      },
      {
        value: ChatbotFollowUpAssertiveness.Assertive,
        label: 'Assertive',
        icon: 'chart3',
      },
    ]

    return (
      <>
        <DaysDropdown
          label='Follow-up window'
          followUpWindow={followUpWindow}
          setFollowUpWindow={setFollowUpWindow}
          days={[
            { value: 3, label: '3' },
            { value: 7, label: '7' },
            { value: 14, label: '14' },
          ]}
        />
        <div className={styles.followUpAssertivenessWrapper}>
          <Typography
            variant='text-input-field-r'
            color='var(--content-primary-secondary)'
            ariaLabel={'followUpAssertivenessLabel'}
            className={styles.followUpAssertivenessLabel}
            marginBottom={12}
          >
            How often should the agent follow up?
            <ChatbotTooltip
              tooltipProps={{
                label: 'The agent follows up within the set window.',
                desc: (
                  <>
                    <span className={styles.tooltipValue}>• Subtle:</span> Few reminders
                    <br />
                    <span className={styles.tooltipValue}>• Steady:</span> Balanced reminders
                    <br /> <span className={styles.tooltipValue}>• Assertive: </span>
                    Frequent reminders
                  </>
                ),
                type: 'description',
                placement: 'top',
                breakWord: true,
                maxWidth: 360,
              }}
              fontSize={14}
            />
          </Typography>
          <SettingsTabs
            tabsList={followUpAssertivenessList}
            selectedValue={followUpAssertiveness}
            setSelectedValue={(value) =>
              setFollowUpAssertiveness(value as IChatbotFollowUpAssertiveness)
            }
            tabsClassName={tabsClassName}
          />
        </div>
      </>
    )
  }
)
